"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddOnsTypes;
(function (AddOnsTypes) {
    AddOnsTypes["GUARANTEED_COE"] = "Guaranteed COE";
})(AddOnsTypes = exports.AddOnsTypes || (exports.AddOnsTypes = {}));
